/*改变true或false的状态*/
function changeFlag(name) {
    if (typeof name !== "boolean") return false;
    if (name) {
      name = false;
    } else {
      name = true;
    }
    return name;
  }
  
  /**
   * 对日期进行格式化，
   * @param {String | Integer} data   要格式化的日期
   * @param {String} format 进行格式化的模式字符串
   *     支持的模式字母有：
   *     y:年,
   *     M:年中的月份(1-12),
   *     d:月份中的天(1-31),
   *     h:小时(0-23),
   *     m:分(0-59),
   *     s:秒(0-59),
   *     S:毫秒(0-999),
   *     q:季度(1-4)
   * @return String
   */
  function dateFormat(date, format) {
    date = new Date(date);
    var map = {
      M: date.getMonth() + 1, // 月份
      d: date.getDate(), // 日
      h: date.getHours(), // 小时
      m: date.getMinutes(), // 分
      s: date.getSeconds(), // 秒
      q: Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds() // 毫秒
    };
    format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
      var v = map[t];
      if (v !== undefined) {
        if (all.length > 1) {
          v = "0" + v;
          v = v.substr(v.length - 2);
        }
        return v;
      } else if (t === "y") {
        return (date.getFullYear() + "").substr(4 - all.length);
      }
      return all;
    });
    return format;
  }
  
  function formatter_safari(date, fomtt) {
    // alert(date)
    date = date.replace(/-/g, "/");
    date = date.replace(/T/g, " ");
    date = date.substring(0, 19);
    date = new Date(date);
    let YYYY = date.getFullYear();
    let MM = date.getMonth() + 1;
    let DD = date.getDate();
    let HH = date.getHours();
    let mm = date.getMinutes();
    let ss = date.getSeconds();
  
    if (MM < 10) {
      MM = "0" + MM;
    }
  
    if (DD < 10) {
      DD = "0" + DD;
    }
  
    if (HH < 10) {
      HH = "0" + HH;
    }
  
    if (mm < 10) {
      mm = "0" + mm;
    }
  
    if (ss < 10) {
      ss = "0" + ss;
    }
  
    switch (fomtt) {
      case "YYYY-MM-DD":
        return YYYY + "-" + MM + "-" + DD;
      case "YYYY-MM":
        return YYYY + "-" + MM;
      case "YYYY-MM-DD HH:mm:ss":
        return YYYY + "-" + MM + "-" + DD + " " + HH + ":" + mm + ":" + ss;
    }
  }
  
  /*手机正则*/
  function testPhone(num) {
    const reg = /^1[3456789]\d{9}$/;
    return reg.test(num);
  }
  
  /*身份证正则*/
  function testID(num) {
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    return reg.test(num);
  }
  
  // 倒计时小时（传创建时间）
  function timeDown(startTime, num, type) {
    if (!startTime) return "";
    var dd, hh, mm, ss;
    var startTime1 = new Date(Date.parse(startTime.replace(/-/g, "/")));
    var endTime = startTime1.getTime() + num * 60 * 60 * 1000;
    var time = endTime / 1000 - new Date().getTime() / 1000;
    if (time <= 0) {
      if (type == "hh") {
        return 0;
      } else {
        return "00";
      }
    } else {
      dd = Math.floor(time / 60 / 60 / 24);
      hh = Math.floor((time / 60 / 60) % 24);
      mm = Math.floor(time / 60) - dd * 24 * 60 - hh * 60;
      ss = Math.floor(time) - dd * 24 * 60 * 60 - hh * 60 * 60 - mm * 60;
      if (dd <= 9) dd = "0" + dd;
      if (dd <= 0) dd = 0;
      if (hh <= 9) hh = "0" + hh;
      if (hh <= 0) hh = 0;
      if (mm <= 9) mm = "0" + mm;
      if (ss <= 9) ss = "0" + ss;
      if (type == "dd") {
        return Number(dd);
      } else if (type == "hh") {
        return Number(hh);
      } else if (type == "mm") {
        return String(mm);
      } else if (type == "ss") {
        return String(ss);
      }
    }
  }
  
  /*倒计时*/
  function mmCountDown(endtime, isEn) {
    if (!endtime) return "";
    var dd,
      hh,
      mm,
      ss = 0,
      str;
    var endTime = new Date(Date.parse(endtime.replace(/-/g, "/")));
    var time = endTime.getTime() / 1000 - new Date().getTime() / 1000;
    if (time <= 0) {
      return;
    } else {
      dd = Math.floor(time / 60 / 60 / 24);
      hh = Math.floor((time / 60 / 60) % 24);
      mm = Math.floor(time / 60) - dd * 24 * 60 - hh * 60;
      ss = Math.floor(time) - dd * 24 * 60 * 60 - hh * 60 * 60 - mm * 60;
      if (dd <= 9) dd = "0" + dd;
      if (dd <= 0) dd = 0;
      if (hh <= 9) hh = "0" + hh;
      if (hh <= 0) hh = 0;
      if (mm <= 9) mm = "0" + mm;
      if (ss <= 9) ss = "0" + ss;
      if (isEn) {
        str =
          (dd ? dd + "d " : "") +
          (hh ? hh + "h " : "") +
          mm +
          "m " +
          ss +
          "s " +
          "left";
      } else {
        str =
          (dd ? dd + "天" : "") + (hh ? hh + "时" : "") + mm + "分" + ss + "秒";
      }
  
      return str;
    }
  }
  
  /*
   * url 目标url
   * arg 需要替换的参数名称
   * arg_val 替换后的参数的值
   * return url 参数替换后的url
   */
  function changeURLArg(url, arg, arg_val) {
    if(url.indexOf(arg) > -1) {
      var pattern = arg + "=([^&]*)";
      var replaceText = arg + "=" + arg_val;
      if (url.match(pattern)) {
        var tmp = "/(" + arg + "=)([^&]*)/gi";
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
      } else {
        if (url.match("[?]")) {
          return url + "&" + replaceText;
        } else {
          return url + "?" + replaceText;
        }
      }
    } else {
      return url
    }
  }
  

  
  /**
   * 获取请求参数名对应的值
   * @param  {String} name 参数名字
   * @return {String}
   */
  function getQueryString(name) {
    const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    const res = window.location.search.substr(1).match(reg);
    if (res !== null) return window.decodeURIComponent(res[2]);
    return "";
  }
  
  /**
   * 已知生日获取年龄
   * @param  {String} str 出生日期
   * @return {String}
   */
  function ages(str) {
    var r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
    if (r == null) return false;
    var d = new Date(r[1], r[3] - 1, r[4]);
    if (
      d.getFullYear() == r[1] &&
      d.getMonth() + 1 == r[3] &&
      d.getDate() == r[4]
    ) {
      var Y = new Date().getFullYear();
      return Y - r[1];
    }
    return "输入的日期格式错误！";
  }
  
  /**
   * 设置cookie
   * @param  {String} name
   * @param  {String} value
   * @param  {Number} day
   */
  export function setCookie(name, value, day) {
    let str = name + "=" + encodeURIComponent(value);
    let exp = new Date();
    // let domain = window.location.hostname;
    exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000);
    str += ";expires=" + exp.toGMTString() + ";path=/;";
    document.cookie = str;
  }
  
  /**
   * 获取cookie
   * @param  {String} name
   * @return {String}
   */
  function getCookie(name) {
    if (document.cookie.length > 0) {
      let start = document.cookie.indexOf(name + "=");
      if (start !== -1) {
        start = start + name.length + 1;
        let end = document.cookie.indexOf(";", start);
        if (end === -1) end = document.cookie.length;
        return decodeURIComponent(document.cookie.substring(start, end));
      }
    }
    return "";
  }
  
  /**
   * 删除cookie
   * @param  {String} name
   */
  function delCookie(name) {
    setCookie(name, "", -1);
  }
  
  
  /*
      延时执行
      @param fn function
      @param wait number
      @return function
  */
  function debounce(fn, wait) {
    var timeout = null;
    return function() {
      if (timeout !== null) clearTimeout(timeout);
      timeout = setTimeout(fn, wait);
    };
  }
  
  // 转成英文格式的时间
  function toEnDate(value) {
    if (!value) {
      return "";
    }
    let date = new Date(value.replace(/-/g, "/")); //Wed Jan 02 2019 00:00:00 GMT+0800 (China Standard Time)
  
    let chinaDate = date.toDateString(); //"Tue, 01 Jan 2019 16:00:00 GMT"
  
    //之后的处理是一样的
    let chinaDateArray = chinaDate.split(" "); //["Wed", "Jan", "02", "2019"]
  
    let displayDate = `${chinaDateArray[1]} ${chinaDateArray[2]}, ${chinaDateArray[3]}`; //"Jan 02, 2019"
    return displayDate;
  }
  
  
  function formatSeconds(value) {
    let result = parseInt(value);
    let h =
      Math.floor(result / 3600) < 10
        ? "0" + Math.floor(result / 3600)
        : Math.floor(result / 3600);
    let m =
      Math.floor((result / 60) % 60) < 10
        ? "0" + Math.floor((result / 60) % 60)
        : Math.floor((result / 60) % 60);
    let s =
      Math.floor(result % 60) < 10
        ? "0" + Math.floor(result % 60)
        : Math.floor(result % 60);
    if (h === "00") {
      result = `${m}:${s}`;
    } else {
      result = `${h}:${m}:${s}`;
    }
    return result;
  }
  
  
  export const publicFunc = {
    changeFlag,
    testPhone,
    testID,
    mmCountDown,
    changeURLArg,
    getQueryString,
    dateFormat,
    getCookie,
    setCookie,
    delCookie,
    debounce,
    toEnDate,
    formatter_safari,
    ages,
    timeDown,
    formatSeconds
  };
  